import { Box, Image, InputGroup, Text, VStack } from "@chakra-ui/react";
import React,{useState} from "react";
import PrimaryInput from "../../components/primary-input";
import PrimaryButton from "../../components/primary-button";
import {
  PrimaryInputDropdown,
  Toaster,
} from "../../components";
import {
 
  InputRightElement,

} from "@chakra-ui/react";
import { generateOtp } from "../../middleware/services/login";
import OtpIndexForgotPassword from "./otp";


const ForgotPassword = ({doctoremail}) => {
  const { showSuccessToast, showErrorToast } = Toaster();
  const [isError, setIsError] = useState(false);
  let emailFromLocal = localStorage.getItem("email")
  const [email, setEmail] = useState(emailFromLocal ? emailFromLocal : "");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [GeneratedOTP, setGeneratedOTP] = useState("");
  const [ShowForgotPasswordOTP, setShowForgotPasswordOTP] = useState(false);
  const emailRegex = /^\s*[^\s@]+@[^\s@]+\.[^\s@]+\s*$/;



  const handleEmailChange = (e) => {
    const sanitizedValue = e.target.value.replace(/[^\x00-\x7F]/g, '')
    setIsError(false);
      setEmail(sanitizedValue.slice(0, 50));

    const newEmail = e.target.value.replace(/[^\x00-\x7F]/g, '');
    setIsButtonDisabled(newEmail.trim() === "");
    if (newEmail.trim() === "") {
      setIsError(false);
    }
  };
  const handleEmailpassKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLoginSubmit();
    }
  };
  const handleMobileKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLoginSubmit();
    }
  };

  const handleLoginSubmit = async () => {
    try {
      const isEmail = emailRegex.test(email);
      const payload = {
        type: "forgotpassword",
        language: "en",
        ispatient: 0,
        loginid: null,
      };

      if (isEmail) {
        payload.email = email.trim();
        payload.countrycode = "1";
        payload.countryid = 1;
      } else {
        payload.mobileno = mobile.trim();
        payload.countryid = localStorage.getItem("countrycode");
        payload.countrycode = localStorage.getItem("countryid");
      }

      const response = await generateOtp(payload);

      if (response.output.result === "success") {
        if (response.output.otp != null) {
          setGeneratedOTP(response.output.otp);
          setEmail(response.output.email);
          setMobileNo(response.output.mobilenumber);
        }
        setShowForgotPasswordOTP(true);
      } else if (
        response.output.result === "failure" &&
        response.output.message === "user do not exists"
      ) {
        showErrorToast(
          isEmail
            ? "The email you entered doesn't exist."
            : "The mobile no you entered doesn't exist."
        );
      } else {
        showErrorToast("Something went wrong");
      }
    } catch (error) {
      console.error("Login failed:", error.response.data);
    }
  };

  const [countrycode, setCountrycode] = useState('')
    const [mobile, setMobileNo] = useState("");

  const handleMobileChange = (e) => {
    var countrycode = localStorage.getItem("countryid")
    setCountrycode(countrycode)

    setIsError(false);
    const inputText = e.target.value;
    const maxLength = 10;
  
    // Limit the input to a maximum length of 10 characters
    if (inputText.length <= maxLength) {
      setMobileNo(inputText);
    }

    setMobileNo(e.target.value);
    setMobileNo(e.target.value.replace(/\D/g, "").slice(0, 10)); // Remove non-digit characters
    const newMobile = e.target.value;
    setIsButtonDisabled(newMobile.trim() === "");
    if (newMobile.trim() === "") {
      setIsError(false);
    }
  };
  return (
    <>
    {!ShowForgotPasswordOTP &&
      <VStack
        // spacing={4}
        p={{base: 4, lg: 8}}
        m={{base: 2, lg: 4}}
        // mt={{base: "-105px", lg: 4}}
        width={{base: "100%", lg: "400px"}}
        gap="0"
      >
        <Box mb="20px">
          <Image
            src="/assets/imgs/forgot-pass.png"
            w="58px"
            h="auto"
            borderRadius="10px"
          />
        </Box>
        <Box as="h1" mb="10px">Forgot Password</Box>

        <Box mb="30px">
          <Text textAlign="center" lineHeight="normal">
            Enter your email or mobile number, and we'll send a code to your registered whatsApp or email.
            {/* Enter your email, and we'll send a code to verify your account. */}
          </Text>
        </Box>

        <InputGroup mb="20px">
          {doctoremail ? <PrimaryInput
           variant="fullRound"
            inputPlace="Enter Email Address"
            defaultValue={doctoremail} 
            inputValue={email}
            onChange={(e) => handleEmailChange(e)}  
            onKeyPress={handleEmailpassKeyPress}
            /> : 
            <PrimaryInputDropdown
            variant="defaultSide"
            inputStyle={{borderRadius:"0 0 10px 10px"}}
            onChange={(e) => handleMobileChange(e)}
            onKeyPress={handleMobileKeyPress}
            inputValue={mobile}
          />
            }
            {isError && (
                  <InputRightElement h="65%" mr="5px" bg="white" top="10px">
                    <Image src="/assets/imgs/error.png" w="18px" h="auto" />
                  </InputRightElement>
                )}
        </InputGroup>
        <PrimaryButton 
        colorScheme="blue"
         width="full" 
         buttonText="Login" 
         onClick={handleLoginSubmit}
         />
      </VStack>
     }
       {/* OTP component start*/}
       {ShowForgotPasswordOTP && <OtpIndexForgotPassword otp={GeneratedOTP} mobile={email || mobile} isForgotPassword={true}/>}
            {/* OTP component end */}
    </>
  );
};

export default ForgotPassword;
